import call from '../../../core/services/http';
import { apiAction } from '../../../core/services/http/apiAction';
import notificationConstants from './notificationConstants';
import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  GET_UNREAD_COUNT_REQUEST,
  GET_UNREAD_COUNT_SUCCESS,
  GET_UNREAD_COUNT_FAILURE,
  POST_MARK_AS_READ_REQUEST,
  POST_MARK_AS_READ_SUCCESS,
  POST_MARK_AS_READ_FAILURE,
  POST_MARK_ALL_AS_READ_REQUEST,
  POST_MARK_ALL_AS_READ_SUCCESS,
  POST_MARK_ALL_AS_READ_FAILURE,
} from './notificationActionTypes';

/** `{ page, rowsPerPage, unread }` */
export const getNotifications = (params) =>
  apiAction({
    types: [GET_NOTIFICATIONS_REQUEST, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS_FAILURE],
    url: notificationConstants.NOTIFICATIONS(params),
  });

/** The bell badge. Polled, so a failure stays quiet in the reducer. */
export const getUnreadCount = () => async (dispatch) => {
  dispatch({ type: GET_UNREAD_COUNT_REQUEST });
  try {
    const response = await call('get', notificationConstants.UNREAD_COUNT);
    dispatch({ type: GET_UNREAD_COUNT_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({ type: GET_UNREAD_COUNT_FAILURE });
  }
};

export const markAsRead = (id) =>
  apiAction({
    types: [POST_MARK_AS_READ_REQUEST, POST_MARK_AS_READ_SUCCESS, POST_MARK_AS_READ_FAILURE],
    method: 'post',
    url: notificationConstants.MARK_AS_READ(id),
    requestMeta: { id },
  });

export const markAllAsRead = () =>
  apiAction({
    types: [POST_MARK_ALL_AS_READ_REQUEST, POST_MARK_ALL_AS_READ_SUCCESS, POST_MARK_ALL_AS_READ_FAILURE],
    method: 'post',
    url: notificationConstants.MARK_ALL_AS_READ,
    toastOnSuccess: true,
  });
